import { AccordionDetails as MuiAccordionDetails } from '@mui/material';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import accordionDetailsStyleBuilder from './accordionDetailsStyleBuilder';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { jsx as _jsx } from "react/jsx-runtime";
/** Component that expand to reveal its content  */
export const AccordionDetails = props => {
  const {
    children,
    contained = false,
    sx,
    id,
    className,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  const style = mergeSxStyle(accordionDetailsStyleBuilder(theme, contained), sx);
  return /*#__PURE__*/_jsx(MuiAccordionDetails, {
    id: id,
    "data-testid": rest['data-testid'],
    sx: style,
    className: className,
    children: children
  });
};